"use client";

import React from "react";
import { Check, GraduationCap, Globe, Stethoscope, TriangleAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";
const batches = [{
  title: "Standard",
  description: "Perfekt for mindre bedrifter som ønsker å starte sin AI-reise med grunnleggende automatisering.",
  icon: GraduationCap,
  features: ["1 Tilpasset AI-Agent", "E-post automatisering", "Grunnleggende CRM-integrasjon", "Månedlig vedlikehold"],
  isRecommended: false,
  buttonText: "Velg Standard",
  link: "/ContactPage"
}, {
  title: "Proff",
  description: "Vår mest populære pakke for bedrifter som krever dypere integrasjon og flere agenter.",
  icon: Globe,
  features: ["3 Tilpassede AI-Agenter", "Full arbeidsflyt-automatisering", "Avansert API-integrasjon", "Prioritert support 24/7", "Ukentlig ytelsesanalyse"],
  isRecommended: true,
  buttonText: "Velg Proff",
  link: "/ContactPage"
}, {
  title: "Ultimat",
  description: "Skreddersydd enterprise-løsning for fullskala digital transformasjon og AI-skalering.",
  icon: Stethoscope,
  features: ["Ubegrenset antall AI-Agenter", "Egendefinerte LLM-modeller", "On-premise distribusjon", "Dedikert AI-strategist"],
  isRecommended: false,
  buttonText: "Velg Ultimat",
  link: "/ContactPage"
}];
export default function VelgDinAiAutomatiseringPakke() {
  return;
}